const request = require('superagent');

const ZoneAPI = {
    getZones: () => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/zones/zones_with_countries`)
        .set('Accept', 'application/json')
        .send(),
};

export default ZoneAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/zones.js
 **/